(() => {
  const copyElement = document.getElementById('LsEmailPopupCopy');
  if (!copyElement) return;
  const copy = JSON.parse(copyElement.textContent);
  const original = {
    heading: 'Get 10% off your first order',
    subheading: 'Join our email list for squishy drops and your first-order code.',
    fieldPlaceholder: 'Email address',
    submitText: 'Email me my code',
    declineText: 'No thanks',
    consentText: 'I agree to receive marketing emails from LoveSquishy. I can unsubscribe anytime.',
    successHeading: 'Check your inbox',
    successBody: 'We’ll email your first-order code. Check your inbox to start shopping.',
    closeLabel: 'Close',
  };
  const replacements = new Map(Object.keys(original).map((key) => [original[key], copy[key]]));
  const seen = new WeakSet();
  const nativeTemplate = document.getElementById('LsNativeNewsletterPopup');

  function useNativeForm(root) {
    if (!nativeTemplate || window.Shopify?.shop !== 'bt21g0-fy.myshopify.com') return;
    const heading = root.querySelector('h1, h2, h3, [role="heading"]')?.textContent.trim();
    if (![original.heading, copy.heading].includes(heading)) return;
    const oldForm = root.querySelector('form');
    if (!oldForm || oldForm.hasAttribute('data-ls-native-newsletter')) return;
    const fragment = nativeTemplate.content.cloneNode(true);
    const form = fragment.querySelector('form');
    const email = form.querySelector('[name="contact[email]"]');
    const consent = form.querySelector('[data-ls-consent]');
    const submit = form.querySelector('[type="submit"]');
    const oldEmail = oldForm.querySelector('input[type="email"]');
    const oldConsent = oldForm.querySelector('input[type="checkbox"]');
    form.className = oldForm.className;
    if (oldEmail) {
      email.className = oldEmail.className;
      email.value = oldEmail.value;
    }
    consent.checked = Boolean(oldConsent?.checked);
    const consentLabel = form.querySelector('[data-ls-consent-label]');
    consentLabel.className = oldConsent?.closest('label')?.className || '';
    submit.className = oldForm.querySelector('[type="submit"]')?.className || '';
    const oldDecline = oldForm.querySelector('button[type="button"]');
    if (oldDecline) {
      const decline = oldDecline.cloneNode(true);
      decline.addEventListener('click', () => oldDecline.click());
      form.append(decline);
    }
    const refresh = () => {
      submit.disabled = !email.value || !email.validity.valid || !consent.checked;
    };
    form.addEventListener('input', refresh);
    form.addEventListener('change', refresh);
    const focusWasEmail = document.activeElement === oldEmail;
    oldForm.replaceWith(fragment);
    refresh();
    if (focusWasEmail) email.focus();
  }

  async function rememberSuccessfulSignup() {
    const shop = window.Shopify?.shop;
    if (shop !== 'bt21g0-fy.myshopify.com') return;
    try {
      const locale = document.documentElement.lang;
      const endpoint = new URL('https://api.emails.judge.me/widgets/popups/config');
      endpoint.searchParams.set('shop', shop);
      endpoint.searchParams.set('locale', locale);
      const response = await fetch(endpoint, { credentials: 'omit' });
      if (!response.ok) return;
      const config = await response.json();
      const frequency = config.frequency || {};
      const days = frequency.mode === 'never_again' ? 3650 : frequency.mode === 'hide_for_days' ? Number.parseInt(frequency.days, 10) || 0 : 365;
      document.cookie = `jm_email_popup_interaction=${Date.now()};path=/;max-age=${days * 86400};SameSite=Lax`;
    } catch {}
  }

  function showNativeResult() {
    const result = nativeTemplate?.content.querySelector('[data-ls-server-result]')?.value;
    if (!result) return;
    const dialog = document.getElementById('LsNativeNewsletterResult');
    if (!dialog) return;
    const heading = dialog.querySelector('[data-ls-result-heading]');
    const body = dialog.querySelector('[data-ls-result-body]');
    if (result === 'success') {
      heading.textContent = copy.successHeading;
      body.textContent = copy.successBody;
      rememberSuccessfulSignup();
    } else {
      heading.textContent = copy.heading;
      const errors = nativeTemplate.content.querySelector('[data-ls-form-errors]');
      if (errors) body.append(errors.cloneNode(true));
    }
    dialog.querySelector('[data-ls-result-close]').addEventListener('click', () => dialog.close());
    dialog.showModal();
  }

  function translated(value) {
    const text = value.trim();
    const replacement = replacements.get(text);
    return replacement && replacement !== text ? value.replace(text, () => replacement) : value;
  }

  function update(root) {
    const heading = root.querySelector('h1, h2, h3, [role="heading"]')?.textContent.trim();
    if (![original.heading, copy.heading, original.successHeading, copy.successHeading].includes(heading)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script, style, textarea')) continue;
      const value = translated(node.nodeValue);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
    root.querySelectorAll('[aria-label], [placeholder]').forEach((element) => {
      ['aria-label', 'placeholder'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (value === null) return;
        const replacement = translated(value);
        if (replacement !== value) element.setAttribute(attribute, replacement);
      });
    });
  }

  function observe(root) {
    if (seen.has(root)) return;
    seen.add(root);
    update(root);
    useNativeForm(root);
    const observer = new MutationObserver(() => {
      if (!root.isConnected) return observer.disconnect();
      update(root);
      useNativeForm(root);
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'placeholder'] });
  }

  function start() {
    showNativeResult();
    const roots = document.querySelectorAll('[data-jme-widget="popup"]');
    roots.forEach(observe);
    if (roots.length) return;
    const pending = new MutationObserver(() => {
      const root = document.querySelector('[data-jme-widget="popup"]');
      if (!root) return;
      observe(root);
      pending.disconnect();
    });
    pending.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
